var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypescriptWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.256,
    height: 115.256,
    viewBox: "0 0 115.256 115.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Typescript-white",
    d: "M0,0H115.256V115.256H0ZM76.837,46.1a15.367,15.367,0,0,0,0,30.735h7.684a7.684,7.684,0,0,1,0,15.367H76.837a7.684,7.684,0,0,1-7.684-7.684H61.47A15.367,15.367,0,0,0,76.837,99.889h7.684a15.367,15.367,0,0,0,0-30.735H76.837a7.684,7.684,0,0,1,0-15.367H85.8a6.4,6.4,0,0,1,6.4,6.4V61.47h7.684V60.189A14.087,14.087,0,0,0,85.8,46.1Zm-53.786,0H61.47v7.684H46.1v46.1H38.419v-46.1H23.051Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptWhite);
export default __webpack_public_path__ + "static/media/Typescript-white.d676d757922180cbdffc33f71ebad044.svg";
export { ForwardRef as ReactComponent };